import React, {useMemo, memo} from 'react';
import {View, StyleSheet} from 'react-native';
import {OrderStatusDto} from '../model/types';
import {useTheme} from '../theme/BrandThemeProvider';
import {tokens} from '../theme/tokens';
import Header from './Header';
import ProgressRail from './ProgressRail';
import Actions from './Actions';
import {STEP_LABELS} from '../model/steps';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

export const ActivityCard: React.FC<{
  order: OrderStatusDto;
  onViewReceipt: (id: string) => void;
}> = memo(({order, onViewReceipt}) => {
  const theme = useTheme();
  const labels = useMemo(() => STEP_LABELS[order.orderType], [order.orderType]);
  const themedCardStyle = useMemo(
    () => [{backgroundColor: theme.bg.card}, styles.cardShadow],
    [theme.bg.card],
  );

  return (
    <View
      style={[styles.card, themedCardStyle]}
      accessible
      accessibilityRole="progressbar"
      accessibilityValue={{min: 1, max: 3, now: order.currentStep}}
      accessibilityLabel={`${labels[order.currentStep - 1]}. ${
        order.currentStep
      } of 3.`}
    >
      <Header
        orderType={order.orderType}
        etaText={order.etaText}
        estimatedPickupTime={order.estimatedPickupTime}
        pickupTimeZone={order.pickupTimeZone}
        pickupLocation={order.pickupLocation}
        locationName={order.locationName}
        isReady={order.isReady}
      />
      <ProgressRail currentStep={order.currentStep} labels={labels} />
      <Actions orderId={order.id} onViewReceipt={onViewReceipt} />
    </View>
  );
});

const styles = StyleSheet.create({
  card: {
    borderRadius: tokens.radius.card,
    padding: tokens.spacing.md,
    marginBottom: tokens.spacing.xs,
  },
  cardShadow: {
    ...getLayoutDescriber().shadowStyles().lightShadow,
  },
});
export default ActivityCard;
